import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchAuthorTasks() {
      return axios.get('/author-tasks')
    },
    // POST /author-tasks/refresh возвращает свежий снапшот синхронно (не флаг для поллинга,
    // как в Финансах) — компонент просто заменяет данные ответом
    refreshAuthorTasks() {
      return axios.post('/author-tasks/refresh')
    },
  },
}
